export const Enviroments = {
  API_URL: "https://aviator-manager-app.herokuapp.com/",
  API_URL_NODE: "https://api-aviator-new-e377b0de89f5.herokuapp.com/",
  API_URL_IA: "https://api-ia-teleco-66be31886130.herokuapp.com/",
  API_URL_BR4BET: "https://br4bet.com",
  API_URL_LOTOGREEN: "https://oauth-routes-cactus.grupoautoma.com/"
};
